import { handleErrors } from "@/utils/handle-errors";
import { SdkPermission } from "@/interfaces/sdk-permission";
import fetch from "@mv/flow-shared-utils/functions/fetch";
export const savePermission = (permission: SdkPermission) => ({ type: "savePermission", permission });
export const updatePermission = (permission: SdkPermission) => ({ type: "updatePermission", permission });
export const loadAllPermission = () => ({ type: "loadAllPermission" });
export const loadPermission = (permissionId: number) => ({ type: "loadPermission", permissionId });
export const deletePermission = (permissionId: number) => ({ type: "deletePermission", permissionId });

export const actions = {
  loadAllPermission() {
    return fetch(`core/api/permission`)
      .then(handleErrors)
      .then((data) => data);
  },

  loadPermission(context: any, { permissionId }: { permissionId: number }) {
    return fetch(`core/api/permission/${permissionId}`)
      .then(handleErrors)
      .then((data) => data);
  },

  savePermission(state: any, { permission }: { permission: SdkPermission }) {
    return fetch(`core/api/permission`, {
      method: "POST",
      body: JSON.stringify(permission),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  updatePermission(state: any, { permission }: { permission: SdkPermission }) {
    return fetch(`core/api/permission`, {
      method: "PUT",
      body: JSON.stringify(permission),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  deletePermission(context: any, { permissionId }: { permissionId: number }) {
    return fetch(`core/api/permission/${permissionId}`, {
      method: "DELETE",
    }).then(handleErrors);
    // .then((data) => data);
  },
};
